import { Container } from 'react-bootstrap';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Link } from 'react-router-dom';

import { AiOutlineHome } from "react-icons/ai";
import { GoBell } from "react-icons/go";
import { BsPersonCircle, BsBookmarkStar } from "react-icons/bs";
import { GiPartyPopper } from "react-icons/gi";
import { RiCoupon3Line } from "react-icons/ri";
import { BiBookBookmark } from "react-icons/bi";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";

import '../App.css';

const Header = () => {
    return (
        <>
            {[false].map((expand) => (
                <Navbar key={expand} expand={expand} className="logobg">
                    <Container fluid id='header_wrap'>
                        <Link to="/Main">
                            <img src='https://kimsikyoung.github.io/images/HaiRound/logo/hairound_logo.png' alt='logo' height="28" width="134"></img>
                        </Link>
                        <Navbar.Toggle id='toggle' aria-controls={`offcanvasNavbar-expand-${expand}`} />
                        <Navbar.Offcanvas
                            id={`offcanvasNavbar-expand-${expand}`}
                            aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                            placement="end"
                        >
                            <Offcanvas.Header closeButton closeVariant='white' className='side_header'>
                                <Offcanvas.Title className='header_top'>
                                    <Link to="/Main" className='logo'>
                                        <img src='https://kimsikyoung.github.io/images/HaiRound/logo/hairound_logo.png' alt='logo'></img>
                                    </Link>
                                    <Link to='/Main' className='nav_icon1'><AiOutlineHome /></Link>
                                    <Link to='/' className='nav_icon2'><GoBell /></Link>
                                </Offcanvas.Title>
                            </Offcanvas.Header>

                            <Offcanvas.Body className='body'>
                                <div className='event'>
                                    <GoBell className='bell' /><a href='#'>(광고)평일 3시 이전 컷트 3,000원 할인 행사 이벤트</a>
                                </div>
                                <div id='myinfo'>
                                    <div className='user'>
                                        <BsPersonCircle className='user_icon' />
                                        <Link to='/Login' className='user_login'>로그인&nbsp;&nbsp;/</Link>
                                        <Link to='/Login' className='user_join'>회원가입</Link>
                                    </div>
                                    <div className='user2'>
                                        <a href='#'>스마트영수증<MdOutlineKeyboardArrowRight /></a>
                                        <a href='#'>이용권<MdOutlineKeyboardArrowRight /></a>
                                        <a href='#'>My Page<MdOutlineKeyboardArrowRight /></a>
                                    </div>
                                </div>
                                <nav id='hair_tab'>
                                    <p className='tab'><p><GiPartyPopper /></p><span>이벤트</span></p>
                                    <p className='tab'><p><RiCoupon3Line /></p><span>쿠폰</span></p>
                                    <p className='tab'><p><BiBookBookmark /></p><span>매거진</span></p>
                                    <p className='tab'><p><BsBookmarkStar /></p><span>찜한목록</span></p>
                                </nav>
                                <div id='QR'>
                                    <div className='code'>
                                        <img src='https://kimsikyoung.github.io/images/HaiRound/img/QR.png' alt='QR'></img>
                                    </div>
                                    <p>QR 코드를 스캔해주세요.</p>
                                </div>
                                <div id='QNA'>
                                    <p>고객센터</p>
                                    <div>
                                        <p>1:1 채팅 상담</p>
                                        <p>공지사항</p>
                                    </div>
                                </div>
                            </Offcanvas.Body>
                            <div id='header_ban'>
                                <div className='banner'>
                                    <img src='https://kimsikyoung.github.io/images/HaiRound/img/header_ban.png' alt='banner'></img>
                                </div>
                            </div>
                        </Navbar.Offcanvas>
                    </Container>
                </Navbar>
            ))}
        </>
    )
};

export default Header;